
import { call, select, put, takeEvery } from 'redux-saga/effects';
import { message } from 'antd';
import folders from "../Actions/folders";
import { saveFoldersRequest, saveFilesRequest, getDataRequest } from '../Api/folders';
import { startLoading, stopLoading } from '../LoadingHelper';
const { addRemoveFolderOption, addRemoveFileOption, selectFile, selectFolder } = folders.actions;

const foldersState = state => state.folders;

export function* saveFolders({data}) {
    const loadingId = yield call(startLoading);
    try {        
        const response = yield call(saveFoldersRequest,data);
        if(response.status === 'success')
            message.success('Ruta de carpetas guardada correctamente', 5);
        else
            message.error(response.message, 5);
    }catch(error) {
        message.error(`Ha ocurrido un error ${error.message}`, 5);
    }finally {		
        yield call(stopLoading, loadingId);
    }
}

export function* saveFileName({data}) {
    const loadingId = yield call(startLoading);
    try {        
        const response = yield call(saveFilesRequest,data);
        if(response.status === 'success')
            message.success('Nombre de archivo guardado correctamente', 5);
        else
            message.error(response.message, 5);
    }catch(error) {
        message.error(`Ha ocurrido un error ${error.message}`, 5);
    }finally {		
        yield call(stopLoading, loadingId);
    }
}

export function* getData() {
    const loadingId = yield call(startLoading);
    const foldersStore = yield select(foldersState);
    const { folders,files } = foldersStore;  
    try {        
        const response = yield call(getDataRequest);
        if(response.status === 'success' && response.data !== null) { 
            const { filePath, fileName } = response.data;
            let names = fileName;
            let paths = filePath;
            
            //FOLDERS       

            if(paths !== '') {                
                if(!filePath.includes('/'))
                    paths = paths.replace(/$/,"/");
                    paths = filePath.split('/');

                let newFolderDataAux = [];             
                paths.forEach(path => {                 
                    folders.forEach( item => {                     
                        if(path === item.pathName){
                            newFolderDataAux.push(item);
                        }
                    })
                });
                let newFolderData = newFolderDataAux.map(item => {
                    item.selected = true;
                    return item;
                });
                let mergedFolderData = folders.map(f => (f.value === newFolderData.value) ? newFolderData : f);
                yield put(addRemoveFolderOption(mergedFolderData));
                yield put(selectFolder(newFolderDataAux));
            } else {
                const defaultFolderOptions = [
                    { value: '5', label: 'RFC Emisor', pathName: 'RFCEmisor', selected: true },
                    { value: '1', label: 'Año de Emisión', pathName: 'AñoDeEmision', selected: true },
                    { value: '2', label: 'Mes de Emisión', pathName: 'MesDeEmision', selected: true },
                    { value: '3', label: 'Día de Emisión ', pathName: 'DiaDeEmision', selected: true }
                ]
                yield put(addRemoveFileOption(defaultFolderOptions));
                yield put(selectFile(defaultFolderOptions));
            }
           
            if(names !== '') {                            
                //FILENAME

                if(!fileName.includes('/'))
                    names = names.replace(/$/,"/");
                    names = fileName.split('/');

                    let newFileNameDataAux = [];
                    names.forEach(name => {                 
                        files.forEach( item => {                     
                            if(name === item.pathName){
                                newFileNameDataAux.push(item);
                            }
                        })
                    });
                    let newFileNameData = newFileNameDataAux.map(item => {
                        item.selected = true;
                        return item;
                    });                    
                    let mergedFileData = files.map(f => (f.value === newFileNameData.value) ? newFileNameData : f);                    
                    yield put(addRemoveFileOption(mergedFileData));
                    yield put(selectFile(newFileNameDataAux));
                
            } else {
                yield put(addRemoveFileOption({ value: '1', label: 'UUID', pathName: 'UUID', selected: true }));
                yield put(selectFile({ value: '1', label: 'UUID', pathName: 'UUID', selected: true }));
            }
            
        }
        
    }catch(error) {
        message.error(`Ha ocurrido un error ${error.message}`, 5);
    }finally {		
        yield call(stopLoading, loadingId);
    }
}


export function* folderSaga() {    
    yield takeEvery(folders.types.SAVE_FOLDERS_PATH, saveFolders);   
    yield takeEvery(folders.types.SAVE_FILE_NAME, saveFileName);
    yield takeEvery(folders.types.GET_FOLDERS_DATA, getData);
}
